<template>
  <div class="heart-list-container dgs heart grid-gua paper-grain" data-product="heart">
    <div class="sheet">

      <div class="rl-head">
        <div class="seal">心</div>
        <h1 class="page-title">面部分析记录</h1>
        <div class="sub">购买过的心动吗分析都在这里</div>
      </div>

      <div v-if="loading" class="loading">加载中...</div>
      <div v-else-if="error" class="error">{{ error }}</div>

      <transition-group v-else name="list" tag="ul" class="list heart-list">
        <li v-for="item in sortedAndFilteredList" :key="item.Id" class="row-item heart-item">
          <div class="thumb">{{ item.name }}</div>
          <div class="meta item-info">
            <div class="t">{{ item.name }}</div>
            <div class="d">日期：{{ formatTime(item.time) }}</div>
          </div>
          <div class="item-details">
            <div class="action-buttons">
              <button @click="viewFullAnalysis(item)" class="view-full-btn go">查看</button>
            </div>
          </div>
        </li>
      </transition-group>

      <div v-if="recordList.length === 0 && !loading" class="no-results">
        没有找到匹配的记录
      </div>
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>等待获取结果，请不要关闭或退出页面</p>
      </div>

      <div class="foot">心动吗 · 原生家庭识人术</div>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage';
export default {
  name: 'heartlist',
  data() {
    return {
      recordList: [],
      loading: true,
      error: '',
      searchQuery: '',
      sortOption: 'time',
      isLoading: false,
    };
  },
  computed: {
    userinfoLove() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      return this.userinfoLove?.unionid || '';
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
    sortedAndFilteredList() {
      return this.recordList
        .filter(item => item.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
        .sort((a, b) => {
          if (this.sortOption === 'time') {
            return new Date(b.time) - new Date(a.time);
          } else {
            return a.name.localeCompare(b.name);
          }
        });
    }
  },
  mounted() {
    if (this.isweixin()) {
      if (!this.unionid) {
        if (!this.code) {
          var url = encodeURIComponent(window.location.protocol + "//" + window.location.hostname + '/heartlist')
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
        } else {
          this.getJsLogin()
        }
      } else {
        // 如果已经有 unionid，直接获取记录
        this.fetchRecords()
      }
    } else {
      // 如果不是微信环境，直接获取记录
      this.fetchRecords()
    }
  },
  methods: {
    getJsLogin(){
      if(this.isweixin){
        const url = '/user/jslogin'
        postAction(url, {code:this.code}).then( res => {
          if(res.data.code == 200){
            this.userInfo = res.data.msg
            // render_words({"jsopenid": r_json['openid'], "unionid": unionid,"nickname":nickname,"image":image, "birthday": login_old.birthday, "sex": login_old.sex}, code=200)
            this.$store.commit('setUserInfoLove', this.userInfo)
            // 登录成功后获取记录
            this.fetchRecords()
          }else{
            this.$router.push({path:'/userRegister'})
          }
        })
      }
    },
    isweixin(){
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    async fetchRecords() {
      const url = '/ai/face/facelist';
      this.loading = true;
      this.error = null;
      const res = await postAction(url, { unionid: this.unionid || 'oni4R6b8pwMrPWp0DoctYi4-Wx4M' })
      if (res.data.code == 200) {
        this.loading = false
        this.recordList = res.data.msg
      } else {
        this.recordList = []
      }

      // postAction(url, { unionid: this.unionid || localStorage.getItem('unionid') })
      //   .then(response => {
      //     // 检查 response.data 是否存在并且包含预期的结构
      //     if (response.data && response.data.code === 200 && Array.isArray(response.data.msg)) {
      //       this.recordList = response.data.msg;
      //     } else {
      //       throw new Error('返回数据格式不符合预期');
      //     }
      //   })
      //   .catch(err => {
      //     this.recordList = [];
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    async gotoResult(item) {
      const url = '/ai/face/heartresult'
      try {
        this.isLoading = true
        const response = await postAction(url, {
          unionid: this.unionid || 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
          filename: item.filename,
          pay: 1,
          name: item.name,
          tm: item.time
        });
        this.isLoading = false
        if (response.data && response.data.code === 200) {
          item.analysisData = response.data.msg;
          this.$set(item, 'showDetails', true);
        } else {
          throw new Error(response.data?.msg || '获取结果失败');
        }
      } catch (err) {
        alert(err.message || '获取结果失败，请稍后重试');
      }
    },
    toggleDetails(item) {
      if (!item.analysisData) {
        this.gotoResult(item);
      } else {
        this.$set(item, 'showDetails', !item.showDetails);
      }
    },
    viewFullAnalysis(item) {
      if (item.analysisData) {
        this.$router.push({
          name: 'heartresult',
          params: { analysisData: item.analysisData },
          query: { from: 'list' }  // 添加一个标记，表示来自列表页面
        });
      } else {
        // 如果还没有加载分析数据，先加载然后再跳转
        this.gotoResult(item).then(() => {
          this.$router.push({
            name: 'heartresult',
            params: { analysisData: item.analysisData },
            query: { from: 'list' }
          });
        });
      }
    },
    deleteReport(id) {
      if (confirm('确定要删除这条记录吗？')) {
        postAction('/ai/face/deletereport', { 'Id': id })
          .then(response => {
            if (response.data && response.data.code === 200) {
              // 删除成功，更新记录列表
              this.recordList = this.recordList.filter(item => item.Id !== id);
              // 显示成功消息
              alert(response.data.msg || '删除成功');
            } else {
              // 如果返回的 code 不是 200，也显示返回的消息
              throw new Error(response.data?.msg || '删除失败');
            }
          })
          .catch(err => {
            // 显示错误消息
            alert(err.message || '删除失败，请稍后重试');
          });
      }
    },
    formatTime(timeString) {
      return new Date(timeString).toLocaleString();
    }
  }
};
</script>

<style scoped>
@import "../style/design-system.css";

.dgs {
  --accent-rose:   #c05a7e;
  --accent-rose-dk:  #9c3f5d;
  --accent-rose-soft: #f2dbe3;
}

.rl-head { text-align: center; padding-bottom: 8px; }
.rl-head .seal { width: 56px; height: 56px; font-size: 24px; margin-bottom: 14px; background: var(--accent-rose-dk); }
.rl-head .page-title { font-family: var(--f-serif); font-size: 26px; letter-spacing: .14em; color: var(--ink); }
.rl-head .sub { margin-top: 8px; font-size: 13px; color: var(--ink-mute); }

.heart-list { list-style: none; padding: 0; margin-top: 24px; }

.heart-item { transition: all .3s ease; }
.heart-item:hover { box-shadow: var(--shadow-soft); }

.heart-item .thumb {
  width: 52px; height: 52px; border-radius: 12px; flex: none;
  background: linear-gradient(135deg, var(--accent-rose-soft), rgba(192,90,126,.18));
  display: grid; place-items: center;
  font-family: var(--f-serif); font-size: 20px; color: var(--accent-rose-dk);
}
.heart-item .meta .t { font-size: 15px; font-weight: 600; color: var(--ink); }
.heart-item .meta .d { font-size: 12px; color: var(--ink-mute); margin-top: 3px; }

.item-details, .item-info { margin: 0; padding: 0; }
.item-details .action-buttons { margin: 0; }
.view-full-btn {
  padding: 8px 16px;
  background: var(--accent-rose-dk); color: #fff;
  border-radius: 999px; font-size: 13px;
  box-shadow: 0 4px 10px rgba(156,63,93,.28);
  transition: background .2s;
}
.view-full-btn:hover { background: var(--accent-rose-dk); }

.loading, .error, .no-results {
  text-align: center; color: var(--ink-mute); font-size: 14px; margin-top: 40px;
}

.list-enter-active, .list-leave-active { transition: all .5s; }
.list-enter, .list-leave-to { opacity: 0; transform: translateY(20px); }

.loading-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center;
  flex-direction: column; z-index: 9999; color: #fff;
}
.loading-spinner {
  width: 50px; height: 50px; border: 3px solid #fff; border-top: 3px solid var(--accent-rose-dk);
  border-radius: 50%; animation: spin 1s linear infinite;
}
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>